export default {
      id: "video-event_right-turn-while-decelerating-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.svg#video-event_right-turn-while-decelerating",
      toString: function () {
        return this.url;
      }
    }